const ONE_HOUR = 60 * 60 * 1000;

export function isCoolingDown(key) {
  try {
    const ts = localStorage.getItem(key);
    if (!ts) return false;
    return Date.now() - Number(ts) < ONE_HOUR;
  } catch {
    return false;
  }
}

export function setCooldown(key) {
  try {
    localStorage.setItem(key, String(Date.now()));
  } catch {}
}

export function dispatchCooldown(key) {
  setCooldown(key);
  window.dispatchEvent(
    new StorageEvent("storage", { key, newValue: String(Date.now()) })
  );
}
